module.exports = __webpack_public_path__ + "img/ic_more.54e792ae.svg";